import { Router } from 'vue-router'
import ROUTER_TYPE from '@/router/routeType'
import * as RouterTypeData from './routerType'

/**
 * router画面遷移関数
 * @param router vue router
 * @returns 取得関数
 */
const useRouterUtil = (router: Router) => {
  /**
   * TOP画面へ遷移する(リダイレクトデータあり)
   * @param input 入力データ
   */
  const top = (input: RouterTypeData.LoginTopData) => {
    router.push({
      name: ROUTER_TYPE.TOP.name,
      params: input,
    })
  }

  /**
   * TOP画面へ遷移する
   */
  const topNoredirect = () => {
    router.push({
      name: ROUTER_TYPE.TOP.name,
    })
  }

  /**
   * ログイン認証画面へ遷移する
   * @param input 入力データ
   */
  const loginAuth = (input: RouterTypeData.LoginAuthData) => {
    router.push({
      name: ROUTER_TYPE.LOGIN.name,
      params: input,
    })
  }
  /**
   * ライセンス契約書同意画面へ遷移する
   * @param input 入力データ
   */
  const agreeLicense = (input: RouterTypeData.AgreeLicenseData) => {
    router.push({
      name: ROUTER_TYPE.AGREE_LICENSE.name,
      params: input,
    })
  }
  /**
   * パスワードリセット画面へ遷移する
   */
  const resetPassword = () => {
    router.push({
      name: ROUTER_TYPE.RESET_PASSWORD.name,
    })
  }
  /**
   * ワンタイムパスワード送信画面へ遷移する
   * @param input 入力データ
   */
  const entryAuthSend = (input: RouterTypeData.EntryAuthSendData) => {
    router.push({
      name: ROUTER_TYPE.ENTRYAUTHSEND.name,
      params: input,
    })
  }
  /**
   * ワンタイムパスワード認証画面へ遷移する
   * @param input 入力データ
   */
  const entryAuth = (input: RouterTypeData.EntryAuthData) => {
    router.push({
      name: ROUTER_TYPE.ENTRYAUTH.name,
      params: input,
    })
  }
  /**
   * パスワード登録画面へ遷移する
   * @param input 入力データ
   */
  const entry = (input: RouterTypeData.EntryData) => {
    router.push({
      name: ROUTER_TYPE.ENTRY.name,
      params: input,
    })
  }
  /**
   * ダウンロード画面へ遷移する
   * @param input 入力データ
   */
  const downlaod = (input: RouterTypeData.DownloadData) => {
    router.push({
      name: ROUTER_TYPE.DOWNLOAD.name,
      params: {
        searchkey: input.downloadKey,
      },
    })
  }
  /**
   * ダウンロード詳細画面へ遷移する
   * @param input ダウンロードデータ
   */
  const downlaodDetail = (input: RouterTypeData.DownloadDetailData) => {
    router.replace({
      name: ROUTER_TYPE.DOWNLOAD_DETAIL.name,
      params: {
        id: input.downloadKey,
        isSearch: input.search,
      },
    })
  }
  /**
   * パスワード変更画面へ遷移する
   */
  const passwordUpdate = () => {
    router.push({
      name: ROUTER_TYPE.USER_EDIT_PASS.name,
    })
  }
  /**
   * ログイン後のデフォルト画面に遷移する
   */
  const defaultRoute = () => {
    const data: RouterTypeData.DownloadData = {}
    downlaod(data)
  }

  /**
   * ログイン後画面に遷移する
   * @param input 入力データ
   */
  const loginAfter = (input?: RouterTypeData.LoginTopData) => {
    // 引数が無い場合はデフォルト画面に遷移する
    if (input === undefined) {
      defaultRoute()
      return
    }
    // 正常時の場合は画面遷移を実施する
    switch (input.redirect) {
      // ダウンロード画面
      case RouterTypeData.REDIRECT_TYPE.DOWNLOAD: {
        const data: RouterTypeData.DownloadData = {
          downloadKey: input.downloadKey,
        }
        downlaod(data)
        break
      }
      // パスワード更新画面
      case RouterTypeData.REDIRECT_TYPE.PASSWORD_UPDATE: {
        passwordUpdate()
        break
      }
      // redirectが設定されていない、または想定外のデータの場合はダウンロード画面に遷移する
      default: {
        defaultRoute()
        break
      }
    }
  }

  return {
    top,
    topNoredirect,
    loginAuth,
    agreeLicense,
    resetPassword,
    entryAuthSend,
    entryAuth,
    entry,
    downlaod,
    downlaodDetail,
    passwordUpdate,
    loginAfter,
  }
}

export { useRouterUtil, RouterTypeData }
